var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "action-record-table" },
    [
      _c(
        "div",
        {
          staticClass: "flex-between",
          staticStyle: { "margin-bottom": "5px" },
        },
        [_c("span", { staticClass: "title-1" }, [_vm._v(_vm._s(_vm.title))])]
      ),
      _c("TableList", {
        staticStyle: { width: "100%" },
        attrs: {
          pagination: _vm.ipagination,
          columns: _vm.columns,
          tableData: _vm.dataSource,
          loading: _vm.loading,
          scroll: {},
        },
        on: { change: _vm.handleTableChange },
      }),
      _vm.showTip
        ? _c(
            "div",
            { staticClass: "tip", staticStyle: { margin: "12px 0 5px" } },
            [_vm._m(0)]
          )
        : _vm._e(),
      _c("DetailModal", {
        ref: "detailModalRef",
        attrs: { title: _vm.title, columns: _vm.columns, url: _vm.url },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("img", {
        staticStyle: { width: "16px", height: "16px", "margin-right": "5px" },
        attrs: {
          src: require("@/assets/imgs/school/monthRecord/warn.png"),
          alt: "",
        },
      }),
      _vm._v(
        "\n      对于未登录使用的班级，建议各级校领导立即督促班主任进行跟进处理，限期2个工作日内完成处理。\n    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }